import {EcSiteApiInterface} from '@/config/axios'

export default {
  // 本人確認依頼 (会員登録)
  registerMail (params = {}) {
    return EcSiteApiInterface.post('/user/mail/register', {
      mail: params.mail
    }).then(res => {
      return res.data
    })
  },

  // 本人確認 (会員登録)
  registerCode (params = {}) {
    return EcSiteApiInterface.put(`/user/mail/register/${params.id}`, {
      authentication_code: params.authentication_code
    }).then(res => {
      return res.data
    })
  },

  // 会員登録
  registerUser (params = {}) {
    return EcSiteApiInterface.post('/user', {
      code_request_id: params.code_request_id,
      surname: params.surname,
      first_name: params.first_name,
      surname_kana: params.surname_kana,
      first_name_kana: params.first_name_kana,
      tel: params.tel,
      post_code: params.post_code,
      prefecture_id: params.prefecture_id,
      city_name: params.city_name,
      address: params.address,
      birthday: params.birthday,
      login_password: params.login_password,
      login_password_confirmation: params.login_password_confirmation
    }).then(res => {
      return res.data
    })
  },

  // 本人確認依頼（パスワードリセット）
  passwordForgotMail (params = {}) {
    return EcSiteApiInterface.post('/user/mail/reset', {
      mail: params.mail
    }).then(res => {
      return res.data
    })
  },

  // 本人確認（パスワードリセット）
  passwordForgotCode (params = {}) {
    return EcSiteApiInterface.put(`/user/mail/reset/${params.id}`, {
      authentication_code: params.authentication_code
    }).then(res => {
      return res.data
    })
  },

  // パスワードリセット
  resetPassword (params = {}) {
    return EcSiteApiInterface.post('/user/reset', {
      code_request_id: params.code_request_id,
      login_password: params.login_password,
      login_password_confirmation: params.login_password_confirmation
    }).then(res => {
      return res.data
    })
  },

  // 会員詳細
  getUser (config = {}) {
    return EcSiteApiInterface.get('/user', config).then(res => {
      return res.data
    })
  },

  // 会員更新
  editUser (params = {}) {
    return EcSiteApiInterface.put('/user', {
      surname: params.surname,
      first_name: params.first_name,
      surname_kana: params.surname_kana,
      first_name_kana: params.first_name_kana,
      tel: params.tel,
      post_code: params.post_code,
      prefecture_id: params.prefecture_id,
      city_name: params.city_name,
      address: params.address,
      birthday: params.birthday
    }).then(res => {
      return res.data
    })
  },

  // 本人確認依頼（メールアドレス変更）
  changeMail (params = {}) {
    return EcSiteApiInterface.post('/user/mail/change', {
      mail: params.mail
    }).then(res => {
      return res.data
    })
  },

  // 本人確認（メールアドレス変更）
  changeMailCode (params = {}) {
    return EcSiteApiInterface.put(`/user/mail/change/${params.id}`, {
      authentication_code: params.authentication_code
    }).then(res => {
      return res.data
    })
  },

  // パスワード変更
  changePassword (params = {}) {
    return EcSiteApiInterface.put('/user/change', {
      login_password: params.login_password,
      new_login_password: params.new_login_password,
      new_login_password_confirmation: params.new_login_password_confirmation
    }).then(res => {
      return res.data
    })
  },

  // 退会
  withdrawal (config = {}) {
    return EcSiteApiInterface.delete('/user/withdraw', config).then(res => {
      return res.data
    })
  }
}



// WEBPACK FOOTER //
// ./src/xhr/xhr-user.js